import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import PropTypes from 'prop-types';

const FiltrosEmpleados = ({
    filtroCategoria,
    filtroEstatus,
    searchFilter,
    onCategoriaChange,
    onEstatusChange,
    onSearchChange
}) => {
    return (
        <Row className="gx-3 gy-2 align-items-end">
            {/* Filtro de Categor�as */}
            <Col xs={12} sm={6} md={3} lg={2}>
                <Form.Group>
                    <Form.Label className="mb-1 fs--2 text-600">Categorias:</Form.Label>
                    <Form.Select
                        size="sm"
                        value={filtroCategoria === null ? 'todos' : filtroCategoria.toString()}
                        onChange={onCategoriaChange}
                    >
                        <option value="todos">Todas</option>
                        <option value="1">Empleado</option>
                        <option value="2">Hon. Prof.</option>
                        <option value="3">Residente</option>
                        <option value="4">Residente becado</option>
                    </Form.Select>
                </Form.Group>
            </Col>

            {/* Filtro de Estatus */}
            <Col xs={12} sm={6} md={3} lg={2}>
                <Form.Group>
                    <Form.Label className="mb-1 fs--2 text-600">Estatus:</Form.Label>
                    <Form.Select
                        size="sm"
                        value={filtroEstatus === null ? 'todos' : filtroEstatus === true ? 'true' : 'false'}
                        onChange={onEstatusChange}
                    >
                        <option value="todos">Todos</option>
                        <option value="true">Activo</option>
                        <option value="false">Inactivo</option>
                    </Form.Select>
                </Form.Group>
            </Col>

            {/* Buscador */}
            <Col xs={12} md={6} className="ms-auto d-flex justify-content-end">
                <div style={{ minWidth: '250px' }}>
                    <AdvanceTableSearchBox
                        globalFilter={searchFilter}
                        setGlobalFilter={onSearchChange}
                        placeholder="Buscar empleado..."
                    />
                </div>
            </Col>
        </Row>
    );
};

FiltrosEmpleados.propTypes = {
    filtroCategoria: PropTypes.number,
    filtroEstatus: PropTypes.bool,
    searchFilter: PropTypes.string,
    onCategoriaChange: PropTypes.func.isRequired,
    onEstatusChange: PropTypes.func.isRequired,
    onSearchChange: PropTypes.func.isRequired
};

export default FiltrosEmpleados;